export var AdminMembersEvents;
(function (AdminMembersEvents) {
    AdminMembersEvents["CLICK_ADD_MEMBERS"] = "workportal_click_add_members";
})(AdminMembersEvents || (AdminMembersEvents = {}));
export var BillingEvents;
(function (BillingEvents) {
    BillingEvents["VIEW_PAYMENT_METHODS"] = "workportal_view_payment_methods";
})(BillingEvents || (BillingEvents = {}));
export var BillingPaymentCardEvents;
(function (BillingPaymentCardEvents) {
    BillingPaymentCardEvents["ADD_CARD_CLICK"] = "ddfw_payment_add_card_click";
    BillingPaymentCardEvents["DELETE_CARD_CLICK"] = "ddfw_payment_delete_card_click";
    BillingPaymentCardEvents["DELETE_CARD_SUCCESS"] = "ddfw_payment_delete_card_success";
    BillingPaymentCardEvents["SET_DEFAULT_CARD_CLICK"] = "ddfw_payment_set_default_card_click";
    BillingPaymentCardEvents["SUPPORT_LINK_CLICK"] = "ddfw_payment_support_link_click";
})(BillingPaymentCardEvents || (BillingPaymentCardEvents = {}));
export var BillingPaymentCardTrackingEvents;
(function (BillingPaymentCardTrackingEvents) {
    BillingPaymentCardTrackingEvents["ADD_METHOD_CLICK"] = "ddfw_payment_add_method_click";
    BillingPaymentCardTrackingEvents["ADD_METHOD_FAILURE"] = "ddfw_payment_add_method_failure";
    BillingPaymentCardTrackingEvents["ADD_METHOD_MENU_CLICKED"] = "ddfw_payment_add_method_menu_clicked";
    BillingPaymentCardTrackingEvents["ADD_METHOD_SUCCESS"] = "ddfw_payment_add_method_success";
    BillingPaymentCardTrackingEvents["ADD_MODAL_TAPPED_BACK"] = "ddfw_payment_add_modal_tapped_back";
})(BillingPaymentCardTrackingEvents || (BillingPaymentCardTrackingEvents = {}));
export var ContactSalesEvents;
(function (ContactSalesEvents) {
    ContactSalesEvents["PAGE_VIEW"] = "work_portal_contact_sales_page_view";
    ContactSalesEvents["MARKETING_SUBMIT_LEAD_SUCESS"] = "work_marketing_lead_form_submit_success";
    ContactSalesEvents["MARKETING_SUBMIT_LEAD_ERROR"] = "work_marketing_lead_form_submit_error";
    ContactSalesEvents["MARKETING_LEAD_FORM_BACK_CLICK"] = "work_marketing_lead_form_back_click";
})(ContactSalesEvents || (ContactSalesEvents = {}));
export var DashPassEvents;
(function (DashPassEvents) {
    DashPassEvents["SELF_SERVE_BENEFIT_ACTIVATION"] = "self_serve_benefit_activation";
    DashPassEvents["SELF_SERVE_BENEFIT_DEACTIVATION"] = "self_serve_benefit_deactivation";
    DashPassEvents["SELF_SERVE_DASHPASS_PAGE_VIEW"] = "self_serve_dashpass_page_view";
    DashPassEvents["SUBSCRIBED"] = "dashpass_subscribed";
    DashPassEvents["SUBSCRIBED_GET_HELP_CLICK"] = "dashpass_subscribed_get_help_click";
    DashPassEvents["UNSUBSCRIBED"] = "dashpass_unsubscribed";
    DashPassEvents["UNSUBSCRIBED_LEARN_MORE_CLICK"] = "dashpass_unsubscribed_learn_more_click";
})(DashPassEvents || (DashPassEvents = {}));
export var EmployeesEvents;
(function (EmployeesEvents) {
    EmployeesEvents["REMOVE_MEMBERS"] = "workportal_remove_members";
    EmployeesEvents["SUBMIT_ADD_MEMBERS"] = "workportal_submit_add_members";
})(EmployeesEvents || (EmployeesEvents = {}));
export var GroupsEvents;
(function (GroupsEvents) {
    GroupsEvents["CLICK_CREATE_GROUP"] = "workportal_click_create_group";
    GroupsEvents["GROUPS"] = "workportal_groups";
    GroupsEvents["SUBMIT_ADD_GROUP"] = "workportal_submit_add_group";
    GroupsEvents["SUBMIT_DELETE_GROUP"] = "workportal_submit_delete_group";
    GroupsEvents["SUBMIT_EDIT_GROUP"] = "workportal_submit_edit_group";
})(GroupsEvents || (GroupsEvents = {}));
export var GroupsMembersEvents;
(function (GroupsMembersEvents) {
    GroupsMembersEvents["GROUPS_MEMBERS_LIST"] = "workportal_groups_members_list";
    GroupsMembersEvents["SUBMIT_REMOVE_GROUP_MEMBER"] = "workportal_submit_remove_group_member";
    GroupsMembersEvents["ADD_MODAL_SUBMIT_EMAILS"] = "work_portal_add_to_group_submit_emails";
    GroupsMembersEvents["ADD_MODAL_INVITE_CLICK"] = "workportal_add_to_group_invite_to_team_and_group_click";
    GroupsMembersEvents["ADD_MODAL_DO_NOT_INVITE_CLICK"] = "work_portal_add_to_group_do_not_invite_click";
    GroupsMembersEvents["ADD_MODAL_INFORM_CANNOT_ADD"] = "work_portal_add_to_group_show_members_cannot_be_added";
    GroupsMembersEvents["ADD_MEMBERS_SUCCESS"] = "work_portal_add_members_success";
})(GroupsMembersEvents || (GroupsMembersEvents = {}));
export var HeaderEvents;
(function (HeaderEvents) {
    HeaderEvents["CLICK_SETTINGS"] = "workportal_click_settings";
})(HeaderEvents || (HeaderEvents = {}));
export var JoinPageEvents;
(function (JoinPageEvents) {
    JoinPageEvents["VIEW_JOIN_PAGE_PENDING"] = "workportal_view_join_page_pending";
    JoinPageEvents["VIEW_JOIN_PAGE_SUCCESS"] = "workportal_view_join_page_success";
})(JoinPageEvents || (JoinPageEvents = {}));
export var MealBudgetsEvents;
(function (MealBudgetsEvents) {
    MealBudgetsEvents["CLICK_ADD_BUDGET"] = "workportal_click_add_budget";
    MealBudgetsEvents["DELETE_BUDGET"] = "workportal_delete_budget";
    MealBudgetsEvents["EDIT_BUDGET"] = "workportal_edit_budget";
    MealBudgetsEvents["EXPENSED_MEALS_LEARN_MORE_CLICK"] = "expensed_meals_learn_more_click";
    MealBudgetsEvents["EXPENSED_MEALS_UNSUBSCRIBED"] = "expensed_meals_unsubscribed";
    MealBudgetsEvents["SUBMIT_ADD_BUDGET"] = "workportal_submit_add_budget";
    MealBudgetsEvents["VIEW_BUDGETS"] = "workportal_view_budgets";
    MealBudgetsEvents["BUDGET_REMINDER_MODAL_VIEWED"] = "work_portal_budget_reminder_modal_viewed";
    MealBudgetsEvents["BUDGET_CREATION_REMINDER"] = "work_portal_budget_creation_reminder";
    MealBudgetsEvents["BUDGET_CREATION_REMINDER_CANCELLED"] = "work_portal_budget_creation_reminder_cancelled";
})(MealBudgetsEvents || (MealBudgetsEvents = {}));
export var NavigationEvents;
(function (NavigationEvents) {
    NavigationEvents["NAV_ITEM_CLICK"] = "work_portal_nav_item_click";
})(NavigationEvents || (NavigationEvents = {}));
export var OnboardingEvents;
(function (OnboardingEvents) {
    OnboardingEvents["VERSION_VIEW"] = "work_portal_onboarding_version";
    OnboardingEvents["SELECTION_PAGE_VIEW"] = "work_portal_onboarding_selection_page_view";
    OnboardingEvents["SETUP_SELECTED_SUBMIT"] = "work_portal_onboarding_setup_selected_submit";
    OnboardingEvents["QUICK_SETUP_SUBMIT"] = "work_portal_onboarding_quick_setup_submit";
    OnboardingEvents["CREATE_BUDGET_SUCCESS"] = "work_portal_onboarding_create_budget_success";
    OnboardingEvents["CREATE_BUDGET_FAILURE"] = "work_portal_onboarding_create_budget_failure";
    OnboardingEvents["SUCCESS_PAGE_VIEW"] = "work_portal_onboarding_success_page_view";
    OnboardingEvents["ACTIONS_CLICK"] = "work_portal_onboarding_redirect_actions_click";
    OnboardingEvents["STEP_CLICK"] = "work_portal_onboarding_step_click";
})(OnboardingEvents || (OnboardingEvents = {}));
export var OptInEvents;
(function (OptInEvents) {
    OptInEvents["PAGE_VIEW"] = "workportal_opt_in_page_view";
    OptInEvents["SUBMIT_EMAIL"] = "workportal_opt_in_submit_email";
})(OptInEvents || (OptInEvents = {}));
export var OrderHistoryEvents;
(function (OrderHistoryEvents) {
    OrderHistoryEvents["ORDER_HISTORY"] = "workportal_order_history";
    OrderHistoryEvents["DOWNLOAD_BILLING_HISTORY"] = "download_billing_history";
})(OrderHistoryEvents || (OrderHistoryEvents = {}));
export var PlaceOrderEvents;
(function (PlaceOrderEvents) {
    PlaceOrderEvents["PAGE_VIEW"] = "work_portal_place_order_page_view";
    PlaceOrderEvents["START_ORDER_CLICK"] = "work_portal_place_order_start_order_click";
    PlaceOrderEvents["CREATE_BUDGET_SUCCESS"] = "work_portal_place_order_create_budget_success";
    PlaceOrderEvents["CREATE_BUDGET_FAIL"] = "work_portal_place_order_create_budget_fail";
    PlaceOrderEvents["FAQ_VIEW"] = "work_portal_place_order_faq_view";
})(PlaceOrderEvents || (PlaceOrderEvents = {}));
export var SelfServeProductOptionsEvents;
(function (SelfServeProductOptionsEvents) {
    SelfServeProductOptionsEvents["PAGE_VIEW"] = "work_portal_self_serve_product_options_page_view";
    SelfServeProductOptionsEvents["RETURN_TO_SELF_SERVE"] = "work_portal_self_serve_return_to_self_serve";
    SelfServeProductOptionsEvents["DASHPASS_SIGN_UP"] = "work_portal_self_serve_dashpass_sign_up";
    SelfServeProductOptionsEvents["EXPENSED_MEALS_SIGN_UP"] = "work_portal_self_serve_expensed_meals_sign_up";
    SelfServeProductOptionsEvents["VIEW_TALK_SALES_MODAL"] = "work_portal_self_serve_view_talk_to_sales_modal";
})(SelfServeProductOptionsEvents || (SelfServeProductOptionsEvents = {}));
export var SelfServeSignupTeamEvents;
(function (SelfServeSignupTeamEvents) {
    SelfServeSignupTeamEvents["DASHPASS_CREATE_TEAM"] = "work_portal_self_serve_dashpass_create_team";
    SelfServeSignupTeamEvents["DASHPASS_CREATE_TEAM_SUCCESS"] = "work_portal_self_serve_dashpass_create_team_success";
    SelfServeSignupTeamEvents["EXPENSED_MEALS_CREATE_TEAM"] = "work_portal_self_serve_expensed_meals_create_team";
    SelfServeSignupTeamEvents["EXPENSED_MEALS_CREATE_TEAM_SUCCESS"] = "work_portal_self_serve_expensed_meals_create_team_success";
})(SelfServeSignupTeamEvents || (SelfServeSignupTeamEvents = {}));
export var TeamNotFoundEvents;
(function (TeamNotFoundEvents) {
    TeamNotFoundEvents["VIEW_EMAIL_NOT_FOUND_PAGE"] = "workportal_view_email_not_found_page";
})(TeamNotFoundEvents || (TeamNotFoundEvents = {}));
export var QuizEvents;
(function (QuizEvents) {
    QuizEvents["PAGE_VIEW"] = "work_portal_self_serve_product_options_page_view";
    QuizEvents["EMAIL_SUBMIT"] = "work_portal_quiz_email_submit";
    QuizEvents["START_OVER_CLICK"] = "work_portal_quiz_start_over_click";
    QuizEvents["CATERING_ORDER_NOW_CLICK"] = "work_portal_quiz_catering_order_now_click";
    QuizEvents["GO_ORDER_NOW_CLICK"] = "work_portal_quiz_go_order_now_click";
    QuizEvents["GO_HOW_TO_PLACE_MODAL_OPEN"] = "work_portal_quiz_go_how_to_place_modal_open";
    QuizEvents["EM_ENROLL_NOW_CLICK"] = "work_portal_quiz_expensed_meals_enroll_now_click";
    QuizEvents["RECOMMENDATION_VIEW"] = "work_portal_quiz_recommended_product_view";
    QuizEvents["OPTION_RESPONSE_SUBMIT"] = "work_portal_quiz_option_submit";
    QuizEvents["BACK_CLICK"] = "work_portal_quiz_back_click";
})(QuizEvents || (QuizEvents = {}));
export var MembershipActivationEvents;
(function (MembershipActivationEvents) {
    MembershipActivationEvents["RESEND_INVITES_SUCCESS"] = "work_portal_send_membership_activation_reminders_success";
    MembershipActivationEvents["RESND_INVITES_FAILED"] = "work_portal_send_membership_activation_reminders_failed";
    MembershipActivationEvents["CLOSE_RESEND_INVITES_BANNER"] = "work_portal_close_membership_activation_reminders_banner";
})(MembershipActivationEvents || (MembershipActivationEvents = {}));
